import React, {useEffect} from 'react';
import { createRoot } from "react-dom/client";
import {Provider} from 'react-redux';
import {Route, Switch, withRouter} from "react-router-dom";
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import styled from 'styled-components';

import history from "./app/helpers/history";
import store from "./app/redux/store";
import {setSchool} from './app/redux/actions/common';
import GlobalStyle from './app/themes/globalStyle';
import {MetaTagsHelper} from './app/helpers/MetaTagsHelper';
import {dynamicImport, preloadComponent} from "./app/helpers/common";
import ErrorBoundary from "./app/components/common/ErrorBoundary";
import ScrollToTop from "./app/helpers/ScrollToTop";
import Router from "./app/components/common/Router";

const HeaderChangeCollege = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "HeaderChangeCollege" */ './app/components/HeaderChangeCollege'));
const Footer = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "Footer" */ './app/components/Footer'));
Footer.load().then(() => {});

const Home = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "Home" */ './app/views/app/Home'));
Home.load().then(() => {});

const Questionnaire = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "Questionnaire" */ './app/views/app/Questionnaire'));
const MoveInDetails = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "MoveInDetails" */ './app/views/app/MoveInDetails'));
const YourInfo = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "YourInfo" */ './app/views/app/YourInfo'));
// const HowToUse = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "HowToUse" */ './app/views/app/HowToUse'));
const Matches = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "Matches" */ './app/views/app/Matches'));
// const Congratulations = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "Congratulations" */ './app/views/app/CongratulationsJobHopperPromo'));
const Congratulations = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "Congratulations" */ './app/views/app/Congratulations'));

const CitySearch = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "CitySearch" */ './app/views/app/CitySearch'));
const CityMainPage = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "CityMainPage" */ './app/views/app/CityMainPage'));

const AnimatedSwitch = withRouter(({location, history}) => {
    if (typeof document !== 'undefined' && document.getElementById('adaptive-right-head-second')) {
        const root = document.getElementById('adaptive-right-head-second');
        createRoot(root).render(<Provider store={store}>
            <HeaderChangeCollege history={history} forceRerender={Date.now()}/>
        </Provider>);
    }

    if (typeof document !== 'undefined' && document.querySelector('.homepage-only')) {
        const homepageOnly = document.querySelectorAll('.homepage-only');
        if (location.pathname && (location.pathname === '/' || location.pathname === '/city-search')) {
            homepageOnly.forEach(function(elem) {
                if(elem.classList.contains('footer')){
                    elem.style.display = 'flex';
                } else {
                    elem.style.display = 'block';
                }
            });
        } else {
            homepageOnly.forEach(function(elem) {
                elem.style.display = 'none';
            });
        }
    }

    return (
        <Container>
            <GlobalStyle/>
            <TransitionGroup>
                <CSSTransition key={location.key} classNames="fade" mode="out-in" timeout={1000}>
                    <Switch location={location}>
                        <Route exact path="/">
                            {MetaTagsHelper.getTags('home')}
                            <Home initCallback={() => {
                                preloadComponent(Questionnaire);

                                const RangeSlider = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "RangeSlider" */ './app/components/forms/components/MaterialUIRangeSlider'));
                                preloadComponent(RangeSlider);
                            }}/>
                        </Route>
                        <Route exact path="/FCXgwtzDII">
                            {MetaTagsHelper.getTags('home')}
                            <Home initCallback={() => {
                                preloadComponent(Questionnaire);

                                const RangeSlider = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "RangeSlider" */ './app/components/forms/components/MaterialUIRangeSlider'));
                                preloadComponent(RangeSlider);
                            }}/>
                        </Route>
                        <Route exact path="/app/housing-questionnaire">
                            {MetaTagsHelper.getTags('questionnaire')}
                            <Questionnaire initCallback={() => {
                                preloadComponent(MoveInDetails);
                            }}/>
                        </Route>
                        <Route exact path="/app/housing-questionnaire-move-in-details">
                            {MetaTagsHelper.getTags('your-info-move-in')}
                            <MoveInDetails initCallback={() => {
                                preloadComponent(YourInfo);
                            }}/>
                        </Route>
                        <Route exact path="/app/housing-questionnaire-your-info">
                            {MetaTagsHelper.getTags('your-info')}
                            <YourInfo initCallback={() => {
                                preloadComponent(Matches);
                            }}/>
                        </Route>
                        {/*<Route exact path="/app/housing-questionnaire-how-to-use-cribwiz">*/}
                        {/*    {MetaTagsHelper.getTags('how-to-use')}*/}
                        {/*    <HowToUse/>*/}
                        {/*</Route>*/}
                        <Route exact path="/app/your-matches">
                            {MetaTagsHelper.getTags('matches')}
                            <Matches initCallback={() => {
                                preloadComponent(Congratulations);
                            }}/>
                        </Route>
                        <Route exact path="/app/congratulations">
                            {MetaTagsHelper.getTags('congratulations')}
                            <Congratulations/>
                        </Route>
                        <Route exact path="/city-search">
                            {MetaTagsHelper.getTags('city-search')}
                            <CitySearch initCallback={() => {
                                preloadComponent(Questionnaire);

                                const RangeSlider = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "RangeSlider" */ './app/components/forms/components/MaterialUIRangeSlider'));
                                preloadComponent(RangeSlider);
                            }}/>
                        </Route>
                        <Route exact path="/city/:stateCityDomain">
                            {(() => {
                                if (typeof store.getState().common === "object" && store.getState().common.contact && Object.keys(store.getState().common.contact).length) {
                                    MetaTagsHelper.getTags('matches');
                                    return (<Matches/>);
                                } else {
                                    MetaTagsHelper.getTags('city');
                                    return (<CityMainPage/>);
                                }
                            })()}
                        </Route>
                    </Switch>
                </CSSTransition>
            </TransitionGroup>
            <Footer location={location}/>
        </Container>
    );
});


const App = function (props) {
    useEffect(() => {
        Home.load().then(() => {});

        if (window?.locationInfo) {
            store.dispatch(setSchool(window.locationInfo));
        }
    }, []);

    return (
        <Provider store={store}>
            <ErrorBoundary boundaryInfo={'app.js App Error'}>
                <Router history={history} location={typeof window !== 'undefined' && window?.location?.path ? window?.location?.path : props.location} forceRerender={Date.now()}>
                    <ScrollToTop/>
                    <AnimatedSwitch history={history}/>
                </Router>
            </ErrorBoundary>
        </Provider>
    );
};

export default App;

const Container = styled.div`
    position: relative;
`;

// if (document.getElementById('app')) {
//     import('./app/views/app/Home').then((module) => {
//         Home = module.default;
//         ReactDOM.render(<App/>, document.getElementById('app'));
//     });
// }

